const IndicatorsMapConfig = {
  marker: {
    weight: {
      selected: 4,
      hover: 4,
      default: 0,
      normal: 0,
    },
    color: {
      default: "#ff7675",
      selected: "#3C6382",
      hover: "#EB1547",
    },
    fillColor: {
      default: "#ff7675",
    },
    radius: {
      default: 10,
      zoom0: 10,
      zoom1: 10,
      zoom2: 10,
      zoom3: 10,
      zoom4: 10,
      zoom5: 10,
      zoom6: 10,
      zoom7: 10,
      zoom8: 10,
      zoom9: 10,
      zoom10: 10,
      zoom11: 10,
      zoom12: 10,
      zoom13: 10,
      zoom14: 10,
      zoom15: 10,
      zoom16: 10,
      zoom17: 10,
      zoom18: 10,
      zoom19: 10,
      zoom20: 10,
    },
  },
};

export default IndicatorsMapConfig;
